import { http, camelify } from '../rest';

let id = 100;

export function inviteClient(http, camelify, demo) {
  return {
    async execute({
      firstName, lastName, email, fee, message, locale,
    }) {
      const params = {
        first_name: firstName,
        last_name: lastName,
        email,
        fee,
        message,
        locale,
      };

      /* istanbul ignore next: development data */
      if (demo) {
        id += 1;
        const clientId = id.toString();
        return {
          invitation: {
            id: clientId,
            firstName,
            lastName,
            email,
            phone: null,
            fee,
            invitedAt: new Date().toISOString(),
            joinedAt: null,
            assets: 0,
          },
        };
      }

      try {
        const result = await http.post('/client_invitations', params);
        return {
          isUpdate: result.data.is_update,
          invitation: {
            id: result.data.invitation.id,
            firstName: result.data.invitation.first_name,
            lastName: result.data.invitation.last_name,
            email: result.data.invitation.email,
            phone: null,
            fee,
            invitedAt: result.data.invitation.created_at,
            joinedAt: null,
            assets: 0,
          },
        };
      } catch (error) {
        if (error.response
          && error.response.data
          && error.response.data.has_been_accepted === true) {
          return {
            hasBeenAccepted: true,
            clientId: error.response.data.client_id,
          };
        }
        throw error;
      }
    },
  };
}

export default inviteClient(http, camelify, process.env.DEMO);
